
      import { Buffer } from 'buffer'
      import process from 'process'
      window.process = process
      global.Buffer = Buffer
    